import React, { useEffect, useState } from "react";
import {
  ButtonWrapper,
  Description,
  RootContainer,
  Rule,
  RuleTitle,
  RuleTitleWrapper,
  SkipButton,
  SkipButtonContainer,
  Title,
  Button,
} from "./Share.style";
import api from "../../api/api";
import { useDispatch } from "react-redux";
import { openAlert, closeAlert } from "@redux/app/appSlice";
import { Alert } from '@components';
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import ShareModal from "./ShareModal/ShareModal";
import copy from "copy-to-clipboard";
import { SHARE_TYPE } from '@constants';
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from '@router/route.constants';

const Share = ({ bg, onSkip, type }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rules, setRules] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState('');
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  // const [isShareNowClicked, setShareNowClick] = useState(false);

  const ruleText =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? rules?.tc_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? rules?.tc_mm
        : rules?.tc_ch;

  const getTermsAndConditons = () => {
    api
      .getShareTNC({ type })
      .then(({ tnc }) => {
        setRules(tnc)
      })
      .catch((errorMsg) => {
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  }

  useEffect(() => {
    getTermsAndConditons();

    return () => {
      dispatch(closeAlert());
    }

    // eslint-disable-next-line
  }, [])

  // // copy link if copy now is clicked and shareNow is not clicked
  // useEffect(() => {
  //   if (link && !isShareNowClicked) {
  //     copyText(link)
  //   }

  //   // eslint-disable-next-line
  // }, [link, isShareNowClicked])

  const getShareLink = (successCallback) => {
    if (!loading) {
      setLoading(true);
      api
        .getShareLink({ type })
        .then(({ share: { share_id } }) => {
          setLoading(false);

          if(!share_id){
            showAlert({
              message: t("common.featureUnavailableMsg"),
              isError: true,
              successCallback: () => {
                if(type === SHARE_TYPE.NORMAL){
                  navigate(`/${PUBLIC_ROUTE.PROFILE}`)
                }
              }
            })
            return
          }

          const domain = window.location.hostname;
          successCallback(
            `${domain}/view-shared-link?share_id=${share_id}`
          );
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const copyText = (link) => {
    try {
      let isCopied = copy(link);
      if (isCopied) {
        showAlert({
          message: t("common.copied"),
        });
      }
      else {
        showAlert({
          message: t("share.permissionMsg"),
          isError: true,
          successCallback: () => copyText(link),
        });
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleCopyClicked = () => {
    getShareLink((link) => {
      copyText(link);
    });
  };

  const handleShareClicked = () => {
    getShareLink((link) => {
      setLink(link);
      // setShareNowClick(true)
      setOpen(true);
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  return (
    <RootContainer bg={bg}>
      <SkipButtonContainer>
        <SkipButton onClick={onSkip}> {t("common.skip")} </SkipButton>
      </SkipButtonContainer>
      <Title> {t("share.fixedPromoText1")} </Title>
      <Description>
        {t("share.fixedPromoText2").split('-')[0]}<span>Ballone Gabar </span>{t("share.fixedPromoText2").split('-')[1]}
      </Description>
      <RuleTitleWrapper>
        <RuleTitle> {t('common.termsAndConditions')}</RuleTitle>
      </RuleTitleWrapper>
      <Rule
        dangerouslySetInnerHTML={{
          __html: ruleText,
        }}
      />
      <ButtonWrapper>
        <Button copy={"copy"} onClick={handleCopyClicked}>
          {t("share.copyLink")}
        </Button>
        <Button copy={"share"} onClick={handleShareClicked}>
          {t("share.shareNow")}
        </Button>
      </ButtonWrapper>
      <Alert />
      <ShareModal
        link={link}
        open={open}
        handleClose={() => setOpen(false)}
        copy={copyText}
      />
    </RootContainer>
  );
};

export default Share;
